<script lang="ts" setup>
    import {computed} from "vue";

    import DContainer from "../atoms/DContainer.vue";
    import DText from "../atoms/DText.vue";
    import DImg from "../atoms/DImg.vue";

    import type {BaseCardType, NormalizedAsset} from "@songfinch/types";

    const props = defineProps<
        BaseCardType & {
            reviewText?: string;
            logo: NormalizedAsset
        }
    >();

    const cardTheme = computed(() => {
        return props.theme === "dark" ? "shadow" : "dark";
    });
</script>

<template>
    <DContainer
        class="d-press-review-card"
        :data-test-td="dataTestId"
        display="grid"
        variant="card"
        :theme="cardTheme"
    >
        <svg
            class="d-press-review-card-quotes"
            width="56"
            height="51"
            viewBox="0 0 56 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="Quotes"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.157 0C4.99517 0 0 4.99516 0 11.157V39.6086C0 45.7705 4.99517 50.7656 11.157 50.7656C17.3189 50.7656 22.314 45.7705 22.314 39.6086V11.157C22.314 4.99517 17.3189 0 11.157 0ZM44.7293 14.7388C38.5674 14.7388 33.5723 19.734 33.5723 25.8958V39.843C33.5723 46.0048 38.5674 51 44.7293 51C50.8911 51 55.8863 46.0048 55.8863 39.843V25.8958C55.8863 19.734 50.8911 14.7388 44.7293 14.7388Z"
                fill="white"
                fill-opacity="0.16"
            />
        </svg>

        <DText
            class="d-press-review-card-text"
            variant="p-2"
        >
            {{reviewText}}
        </DText>

        <DImg v-if="logo" class="d-press-review-card-logo" :src="logo.url" :alt="logo.title"/>
    </DContainer>
</template>

<style lang="scss" scoped>
.d-press-review-card {
    position: relative;
    padding: 1.875rem;
    border-radius: var(--radius-16);
    width: 270px;
    height: 352px;
}

.d-press-review-card-quotes {
    position: absolute;
    top: 1.875rem;
    left: 1.25rem;
}

.d-press-review-card-text {
    margin-top: 32px;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 8; /* number of lines to show */
    line-clamp: 8;
}

.d-press-review-card-logo {
    margin-top: auto;
}
</style>
